import React from "react";
import "./Dropdown.module.scss";
import {
  Dropdown,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
  Radio,
} from "semantic-ui-react";
import copy from "../../assets/copy/copy.json";
import Icon from "../UI/Icon/Icon";
import buttonStyles from "../../views/MyAvailability/MyAvailability.module.scss";
export default class SetPagingGroupDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.dropdownMenuRef = React.createRef();
    this.state = {
      selectedAgency: this.props.defaultAgency,
      selectedPagingGroup:
        this.props.defaultPagingGroup && this.props.defaultPagingGroup.number,
      dropdownMenuWidth: this.calculateDropdownPosition(),
    };
  }

  //   dynamic width calculator
  calculateDropdownPosition = () => {
    const dropdownMenu = this.dropdownMenuRef.current;
    if (dropdownMenu) {
      const viewportWidth = window.innerWidth;
      const rect = dropdownMenu.getBoundingClientRect();
      const spaceToRight = viewportWidth - rect.left;
      return spaceToRight;
    }
    return null;
  };

  componentDidMount() {
    const dropdownMenuWidth = this.calculateDropdownPosition();
    if (dropdownMenuWidth !== null) {
      this.setState({ dropdownMenuWidth });
    }
        // Add ARIA attributes to the dropdown elements
        document.querySelectorAll(`.${buttonStyles.setPagingGroupButtonClass}`).forEach((dropdown) => {
          dropdown.setAttribute("id","pagingGroupButton");
        });
        document.querySelectorAll('.setPagingGroupDropdownclass .ui.dropdown').forEach((dropdown) => {
          dropdown.setAttribute("role","combobox");
          dropdown.setAttribute("aria-controls","pagingGroupButton");
          dropdown.setAttribute("aria-label","Set paging group dropdown");
        });
        document.querySelectorAll('.setPagingGroupDropdownclass > .ui.dropdown > .menu > .header').forEach((dropdown) => {
          dropdown.setAttribute("role","menuitem");
        });
        document.querySelectorAll('.setPagingGroupDropdownclass > .ui.dropdown > .menu > .header > .ui.selection.dropdown').forEach((dropdown) => {
          dropdown.setAttribute("role","combobox");
          dropdown.setAttribute("aria-label","Select agency dropdown menu")
        });
        document.querySelectorAll('.setPagingGroupDropdownclass .ui.dropdown .menu > .header > .ui.selection.dropdown > .menu').forEach((dropdown) => {
          dropdown.setAttribute("role","listbox");
        });
        document.querySelectorAll('.setPagingGroupDropdownclass .ui.dropdown .menu > .header > .ui.selection.dropdown > .menu > .item').forEach((dropdown) => {
          dropdown.setAttribute("role","option");
        });
        document.querySelectorAll('.setPagingGroupDropdownclass > .ui.dropdown > .menu').forEach((dropdown) => {
          dropdown.setAttribute("role","menu");
        });
        document.querySelectorAll('div.ui.checkbox.radio').forEach((dropdown) => {     
          dropdown.setAttribute("role","menuitemradio");
          dropdown.setAttribute("aria-checked",dropdown.children[0].getAttribute("aria-checked"));
          dropdown.setAttribute("aria-label",dropdown.innerText);      
        });
        document.querySelectorAll('.setPagingGroupDropdownclass > .ui.dropdown > .menu > .menu').forEach((dropdown) => {
          dropdown.setAttribute("role","menu");
          dropdown.setAttribute("aria-label","List of paging groups")
        });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.defaultAgency === nextProps.defaultAgency &&
      this.props.smallScreen === nextProps.smallScreen &&
      this.state.selectedAgency === nextState.selectedAgency
    ) {
      return false
    }
    return true
  }

  componentDidUpdate(prevProps, prevState) {
    const dropdownMenuWidth = this.calculateDropdownPosition();
    if (dropdownMenuWidth !== prevState.dropdownMenuWidth) {
      this.setState({ dropdownMenuWidth });
    }
  }
  render() {
    const {
      setPagingGroupButton,
      smallScreen,
      userAgencies,
      pagingGroups,
      defaultAgency,
    } = this.props;
    const agencyDropdownOptions = userAgencies
      .filter(
        (agency) => pagingGroups && pagingGroups[agency] && pagingGroups[agency].length > 0
      )
      .map((agency) => ({
        key: agency,
        text: agency,
        value: agency,
      }));

    const pagingGroupArray =
      pagingGroups && pagingGroups[this.state.selectedAgency];
    const dropdownMenuClass = `dropdownMenu ${
      smallScreen ? "smallScreen" : "default"
    }`;
    const dropdownMenuStyle = smallScreen
      ? { width: "min-content" }
      : {};
    const dropdownItemStyle = smallScreen 
      ? {width: "190px"}
      : {};
    const innerDropdownMenuStyle = {"maxHeight": "30vh"};
    return (
      <div className="setPagingGroupDropdownclass">
        <Dropdown
          ref={(dropdown) =>
            (this.dropdownMenuRef.current = dropdown?.ref?.current || dropdown)
          }
          trigger={setPagingGroupButton}
          icon={null}
          {...(smallScreen ? { fluid: false } : { fluid: false })}
        >
          <DropdownMenu className={dropdownMenuClass} style={dropdownMenuStyle}>
            <DropdownHeader>
              <span className="dropdownLabeltext">Agency: </span>

              <Dropdown
                compact
                floating
                selection
                options={agencyDropdownOptions}
                defaultValue={defaultAgency}
                placeholder={copy.myAvailabilityScreen.myAvailability.setAgency}
                icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
                onChange={(event, data) => {
                  this.setState({
                    selectedAgency: data.value,
                   });
                }}
              />
            </DropdownHeader>
            {agencyDropdownOptions.length > 0 && <DropdownDivider />}
            <DropdownMenu style={innerDropdownMenuStyle} scrolling>
              {pagingGroupArray &&
                pagingGroupArray.map((option) => (
                  <DropdownItem key={option.key} value={option.value.number} style={dropdownItemStyle}>
                    <Radio
                      name="pagingGroup"
                      label={option.text}
                      value={option.value.number}
                      checked={
                        this.state.selectedPagingGroup === option.value.number
                      }
                      onChange={(event, data) => {
                        this.props.selectPagingGroup({
                          number: option.value.number,
                          text: option.text,
                          agency: option.value.agency,
                        });
                      }}
                    />
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}
